import {
  Card,
  Typography,
  Box,
} from "@mui/material";
import { SubscribeButton } from "./SubscribeButton";

export function ProductCard({ title, price, features, image, isBest, onHover, onLeave, position }) {
  // Background color mapping
  const backgroundMap = {
    left: "#669cf399",
    middle: "#9faff399",
    right: "#ebdadc99"
  };

  const bgColor = isBest ? "#fff" : backgroundMap[position];

  return (
    <Card
  onMouseEnter={onHover}
  onMouseLeave={onLeave}
  sx={{
    borderRadius: "24px",
    background: bgColor,
    boxShadow: isBest
      ? "0px 20px 40px rgba(0, 0, 0, 0.2)"
      : "0px 4px 10px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    width: "100%",
    maxWidth: { xs: "60%", sm: "360px" },
    height: "320px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    px: 2,
    py: 3,
    textAlign: "center",
    marginBottom: { xs: "20px", sm: "30px" },
     "@media (max-width:710px)":{
            height: "340px",
          },
    "@media (max-height:645px)":{
        height: "300px",
    },

    // 👇 Hover effect
    transform: isBest ? "scale(1.05) translateY(-10px)" : "none",
    zIndex: isBest ? 5 : 1,
  }}
>

      {/* Best Value Tag */}
      {isBest && (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            backgroundColor: "#6A5ACD",
            color: "#fff",
            px: 2.5,
            py: 0.5,
            fontSize: "12px",
            fontWeight: 600,
            borderRadius: "30px",
          }}
        >
          Best Value
        </Box>
      )}

      <Box
        component="img"
        src={image}
        alt="product"
        sx={{
          width: "56px",
          height: "56px",
          objectFit: "contain",
          mb: 3.5
        }}
      />

      <Typography
        sx={{
          fontFamily: "Inter600",
          fontWeight: 600,
          color: isBest ? "#000" : "#fff",
          fontSize: "20px",
          mb: 3,
          "@media (max-height:645px)":{
            mb: 2,
          },
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: isBest ? "#000" : "#fff",
          fontFamily: "Inter600",
          fontWeight: 600,
          fontSize: "20px",
          mb: 3,
           "@media (max-height:645px)":{
            mb: 2,
          },
        }}
      >
        ₹{price} <span style={{ fontWeight: 400, fontFamily: "Inter400", fontSize: "14px" }}>/ Year</span>
      </Typography>

      <Typography
        sx={{
          color: isBest ? "#000" : "#fff",
          fontFamily: "Inter400",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "135%",
          mb: 4,
          px: 1,
           "@media (max-width:628px)":{
              px: 0,
           fontSize: "16px",
          },

        }}
      >
        {/*.join(" + ")} */}
         {features}
      </Typography>

      <Box sx={{ width: "100%" }}>
        <SubscribeButton isBest={isBest} />
      </Box>
    </Card>
  );
}
